<!--
 * @FileDescription: 库存引导（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-07-27（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div class="page-container">
      <div class="page-container-height">
          <div class="guide-manage">
              <div class="guide-title">库存管理</div>
              <div class="guide-manage-content">
                  <div class="guide-item" @click="onPage(1)">
                      <img src="@/assets/image/cangku.png"/>
                      <span>仓库管理</span>
                  </div>
                  <img src="@/assets/image/kuncun_guide.png" class="guide-item-img"/>
                  <div class="guide-item" @click="onPage(7)">
                      <img src="@/assets/image/kucunshuliang1.png"/>
                      <span>库存状况</span>
                  </div>
                  <img src="@/assets/image/kuncun_guide.png" class="guide-item-img"/>
                  <div class="guide-item" @click="onPage(3)">
                      <img src="@/assets/image/pandian_guide.png"/>
                      <span>库存盘点</span>
                  </div>
                  <img src="@/assets/image/kuncun_guide.png" class="guide-item-img"/>
                  <div class="guide-item" @click="onPage(4)">
                      <img src="@/assets/image/baosun.png"/>
                      <span>库存报损</span>
                  </div>
                  <img src="@/assets/image/kuncun_guide.png" class="guide-item-img"/>
                  <div class="guide-item"  @click="onPage(5)">
                      <img src="@/assets/image/kucunsunyi.png"/>
                      <span>库存报溢</span>
                  </div>
                  <img src="@/assets/image/kuncun_guide.png" class="guide-item-img"/>
                  <div class="guide-item"  @click="onPage(6)">
                      <img src="@/assets/image/kucunyujing.png"/>
                      <span>库存预警</span>
                  </div>
              </div>
          </div>
          <div class="guide-manage" style="padding-top: 100px">
              <div class="guide-title">标准操作步骤</div>
              <div class="guide-cao-content">
                  <div class="guide-cao-item">1、根据您的门店情况，<span @click="onPage(1)">创建一个或多个仓库</span></div>
                  <div class="guide-cao-item">2、根据仓库的情况，<span @click="onPage(2)">创建一个或多个库位</span></div>
                  <div class="guide-cao-item">3、您的具体业务产生后，实时关注相应的库存信息可在<span  @click="onPage(7)">库存状况</span>中查询</div>
                  <div class="guide-cao-item">4、每个月对库存进行<span @click="onPage(3)">盘点</span>，矫正库存数据 </div>
                  <div class="guide-cao-item">5、通过盘点，会生成和查看库存<span @click="onPage(4)">报损</span>或<span @click="onPage(5)">报溢</span></div>
                  <div class="guide-cao-item">6、您可以设置仓库的预警线，提醒自己及时补货，<span @click="onPage(6)">查看预警</span>信息，去进行采购</div>
              </div>
          </div>
      </div>
  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  },
  components: {


  },
  methods: {
    /**
    * @description: 此为方法注释（方法描述）
    */
      onPage(index){
        if(index == 1){
            if(this.$comm.has('library_warehouse_btn')){
                this.$router.push('/librarymanage/warehouse/warehouse')
            }else{
                 this.$message.warn('您没有此权限哦～')
            }
        }else if(index == 2){
            //库位
            if(this.$comm.has('library_warehouse_btn')){
                this.$router.push('/librarymanage/warehouse/warehouse')
            }else{
                 this.$message.warn('您没有此权限哦～')
            }
        }else if(index == 3){
            this.$router.push('/librarymanage/warehousemanage/inventorycheck')
        }else if(index == 4){
             if(this.$comm.has('library_loss_btn')){
               this.$router.push('/librarymanage/warehousemanage/InventoryLossReport')
            }else{
                 this.$message.warn('您没有此权限哦～')
            }
        }else if(index == 5){
             if(this.$comm.has('library_overflow_btn')){
               this.$router.push('/librarymanage/warehousemanage/InventoryOverflow')
            }else{
                 this.$message.warn('您没有此权限哦～')
            }
        }else if(index == 6){
            if(this.$comm.has('library_analysis_btn')){
               this.$router.push('/librarymanage/warehousemanage/inventoryanalysis')
            }else{
                 this.$message.warn('您没有此权限哦～')
            }
        }else if(index == 7){
            this.$router.push('/librarymanage/warehousemanage/materialmanage')
        }
      }
  },
  watch: {

  },
  mounted () {

  },
  created () {

  }
}
</script>

<style scoped lang="scss">
    .page-container-height{
        background-color: #fff;
        .guide-manage{
            padding: 70px 0 0 98px;
            .guide-manage-content{
                display: flex;
                align-items: center;
                padding-left: 100px;
                .guide-item{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    color: #333333;
                    font-size: 16px;
                    img{
                       width: 96px;
                        margin-bottom: 10px;
                    }
                }
                .guide-item-img{
                    margin: 0 40px 30px;
                }
            }
            .guide-cao-content{
                display: flex;
                flex-direction: column;
                padding-left: 100px;
                color: #333333;
                font-size: 16px;
                .guide-cao-item{
                    margin-bottom: 20px;
                    span{
                        color: #387BFC;
                        cursor: pointer;
                    }
                }
            }
        }
        .guide-title{
            color: #333;
            font-size: 20px;
            font-weight: 700;
            padding-bottom: 60px;
        }
    }
</style>
